import React, { useEffect } from 'react';
import cl from './Checkout.module.css';
import CheckoutForm from './CheckoutForm/CheckoutForm';
import { animateScroll as scroll } from 'react-scroll';
import { getRandomNumber } from '../Home/Home';

const Checkout = (props) => {
  const { cartItems } = props;
  const subTotalPrice = cartItems.reduce((a, c) => a + c.oldPrice * c.qty, 0);
  const totalPrice = cartItems.reduce(
    (a, c) => a + ((c.oldPrice * (100 - c.discount)) / 100) * c.qty,
    0
  );
  const discountPrice = subTotalPrice - totalPrice;

  useEffect(() => {
    scroll.scrollToTop();
  }, []);

  return (
    <section className={cl.main}>
      <h1 style={{ fontSize: '40px' }}>Pago</h1>
      <div
        style={{
          width: '100%',
          height: '50px',
          backgroundColor: 'var(--primary)',
          marginTop: '50px',
        }}
      ></div>
      <div className={cl.checkout_form}>
        <CheckoutForm />
      </div>
      <div
        style={{
          width: '100%',
          height: '25px',
          backgroundColor: 'var(--primary)',
          marginTop: '50px',
        }}
      ></div>
      <div className={cl.cart}>
        <h2 className={cl.header}>Elementos en el carrito</h2>
        <div
          style={{
            width: '100%',
            height: '14px',
            backgroundColor: 'var(--primary)',
            marginTop: '50px',
          }}
        ></div>
        <div>
          {cartItems.length === 0 && (
            <div className={cl.header_empty}>El carrito está vacío</div>
          )}
          {cartItems.map((item) => (
            <div key={getRandomNumber(1, 10000)} className={cl.row}>
              <div className={cl.row_img_container}>
                <img src={item.images[0]} alt="item" />
              </div>
              <p>{item.qty} unidad</p>
              <div className={cl.name}>{item.name}</div>
              <div className={cl.amount}>
                {item.currency}
                {(
                  item.qty *
                  ((item.oldPrice * (100 - item.discount)) / 100)
                ).toFixed(2)}
              </div>
            </div>
          ))}
        </div>
        {cartItems.length !== 0 && (
          <>
            <hr style={{ borderTop: '1px solid var(--primary)' }}></hr>
            <div>
              <div className={cl.price}>
                <div>Subtotal</div>
                <div>
                  {' '}
                  {cartItems[0].currency}
                  {subTotalPrice.toFixed(2)}
                </div>
              </div>
              <div className={cl.price}>
                <div>Descuento</div>
                <div>
                  -{cartItems[0].currency}
                  {discountPrice.toFixed(2)}
                </div>
              </div>
              <div className={cl.price_total}>
                <div>Precio Total</div>
                <div>
                  {' '}
                  {cartItems[0].currency}
                  {totalPrice.toFixed(2)}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default Checkout;
